import apiService from "./apiService";
import AppConstants from "../appConstants";
import convertDatetimeHelper from "../helpers/convert-datetime-helper";
import { CONTENT } from "../enums/enum-content";

class UserService {
    getUserDetails(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_MY_ACCOUNT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateUser(params, form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_MY_ACCOUNT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updatePhone(params, form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_UPDATE_PHONE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    checkUserInfo(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CHECK_INFO, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCurrentSignature(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_CURRENT_SIGNATURE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getUserSignatures(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_SIGNATURES, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    updateUserSignatures(params, form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_SIGNATURES, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserNotification(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_NOTIFICATION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    updateUserNotification(params, form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_NOTIFICATION, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    checkRequestDemo(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_CHECK_REQUEST_DEMO,params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    requestDemo(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_REQUEST_DEMO,params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    sendPassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_RESET_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    changePassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CHANGE_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    forgotPassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_FORGOT_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    requestNewClientAccess(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEW_CLIENT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    lostAccess(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_LOST_ACCESS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================
    getContentPrivate(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_PRIVATE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
    
    getUserCountSentNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_COUNT_SENT_NEWS, params)
            .then(response => {
                response.lastSent = response.lastSent.map(item => {
                    if (item.newsContent[0].code == CONTENT.INFORMATIVE ||
                        item.newsContent[0].code == CONTENT.STATISTIC ||
                        item.newsContent[0].code == CONTENT.EXPORTS) {
                        item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report);
                        item.data_object = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report);
                    } else {
                        item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_publish);
                        item.data_object = new Date(item.dt_publish);
                    }
                    return item;
                });
                resolve(response);
            })
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================

    deleteAccount(params) {
        return new Promise((resolve, reject) => {
            apiService.delete(AppConstants.URL_DELETE_ACCOUNT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateTimeSpent(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_UPDATE_TIME_SPENT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
}

export default new UserService();
